module.exports = __webpack_public_path__ + "static/media/CloudR.e0bec54d.png";